module.exports = __webpack_public_path__ + "img/w-title.0f6dd8b7.svg";